import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { OrderLifetimeAction } from '../orderLifetime.action';

type IDependencies = IClientApiDependencySegment;

export const removeOrderLifetimeEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deleteOrderLifetimeProfile({ id: params.orderLifetimeId }).pipe(
      mergeMap(() => {
        return [
          OrderLifetimeAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          OrderLifetimeAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
